import { useState } from "react";
import { Link } from "react-scroll";
import logo from "../assets/images/logo.jpeg"; // adjust path if needed

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav
      style={{
        background: "var(--black)",
        padding: "15px 30px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "sticky",
        top: 0,
        zIndex: 1000,
      }}
    >
      {/* Logo */}
      <div className="flex items-center space-x-3">
        <img src={logo} alt="CarFinders SA Logo" className="nav-logo" />
      </div>

      {/* Hamburger Icon (mobile only) */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        className="hamburger md:hidden"
        style={{ cursor: "pointer", color: "var(--gold)", fontSize: "24px" }}
      >
        {isOpen ? "✕" : "☰"}
      </div>

      {/* Menu Links */}
      <div className={`nav-links ${isOpen ? "open" : ""}`}>
        <Link to="hero" smooth={true} duration={500}>
          Home
        </Link>
        <Link to="about" smooth={true} duration={500}>
          About
        </Link>
        <Link to="services" smooth={true} duration={500}>
          Services
        </Link>
        <Link to="testimonials" smooth={true} duration={500}>
          Testimonials
        </Link>
        <Link to="contact" smooth={true} duration={500}>
          Contact
        </Link>
      </div>
    </nav>
  );
}
